import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";

import styles from './Pagination.module.scss';
import allCleaningRequests from "../../pages/AllCleaningRequests/AllCleaningRequests";

const Pagination = ({currentPage, onPageChange, type}) => {
    const itemsPerPage = 10;
    const [totalItems, setTotalItems] = useState(null);

    const {totalItems: totalItemsCleaningRequest, allCleaningRequests} = useSelector(state => state.cleaningRequests);
    const {totalItems: totalItemsCleanerApplications} = useSelector(state => state.cleanerApplications);

    useEffect(() => {
        switch (type) {
            case 'cleaning-request': {
                setTotalItems(totalItemsCleaningRequest);
                break;
            }
            case 'applied-cleaner-applications': {
                setTotalItems(totalItemsCleanerApplications);
                break;
            }
        }
    }, [allCleaningRequests]);

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Only show pagination when there's more than one page (10+ items).
    if (!totalPages || totalPages <= 1) {
        return null;
    }

    const pages = [...Array(totalPages).keys()]?.map(num => num + 1);

    return (
        <>
            <div className={styles.pagination_desktop}>
                <button
                    className={`${styles.page} ${currentPage === 1 ? styles.disabled : ''}`}
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Попередня
                </button>

                {pages?.map(page => (
                    <button
                        key={page}
                        className={`${styles.page} ${currentPage === page ? styles.active : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}

                <button
                    className={`${styles.page} ${currentPage === totalPages ? styles.disabled : ''}`}
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Наступна
                </button>
            </div>

            <div className={styles.pagination_mobile}>
                <button
                    className={`${styles.page} ${currentPage === 1 ? styles.disabled : ''}`}
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Попередня
                </button>

                <button className={`${styles.page} ${styles.active}`}>
                    {currentPage}
                </button>

                <button
                    className={`${styles.page} ${currentPage === totalPages ? styles.disabled : ''}`}
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Наступна
                </button>
            </div>
        </>
    );
};

export default Pagination;
